<script setup>
  import { ref, defineAsyncComponent } from 'vue'

  import CompleteReportDataContainerSection from '@/components/CompleteReportDataContainerSection.vue';
  import DataContainer from '@/components/DataContainer.vue';

  const OnsiteReportsContent = defineAsyncComponent(() => import('@/components/OnsiteReportsContent.vue')); 

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    }
  });

  const content = ref(null);
</script>

<template>
    <CompleteReportDataContainerSection
      v-model:content="content"
      sectionId="onsite-reports"
      title="Onsite Reports"
      containerTypeId="Spot Stats"
      minHeight="500px"
      :metaActions="false"
      >
      <template #content>
        <DataContainer style="width: 100%; height: 100%;">
          <OnsiteReportsContent
            v-model:content="content"
          />
        </DataContainer>
      </template>
    </CompleteReportDataContainerSection>
</template>